module.exports = __webpack_public_path__ + "img/handcuffs.6e5ac3a1.svg";